import { render } from "./uploadZBAPList.vue?vue&type=template&id=7a811830&scoped=true"
import script from "./uploadZBAPList.vue?vue&type=script&lang=js"
export * from "./uploadZBAPList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a811830"]])

export default __exports__